module.exports = __webpack_public_path__ + "img/report-5.83141e4d.jpg";